module.exports = __webpack_public_path__ + "static/media/mail.d62dfc87.svg";